'use strict';

module.exports = require('./lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-dom/server.js
 ** module id = 2816
 ** module chunks = 0
 **/